import { useSearchParams } from 'react-router-dom';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { COMMUNITY_AMBASSADOR_FEATURE_FLAG } from '../utils/constants';
import { Container } from '@amzn/awsui-components-react';
import { useAmbassadorAnnualConfirmation } from '../hooks/ambassadors/ambassadorAnnualConfirmation';
import {
  AmbassadorRenewalConfirmationError,
  AmbassadorRenewalConfirmationSuccess,
  VerifyingSpinner,
} from '../components/ambassadors/ambassadorAnnualConfirmationScreens';

export function AmbassadorRenewalConfirmation() {
  const { isLoading, data } = useAmbassadorAnnualConfirmation();

  return (
    <div data-testid="ambassador-renewal-confirmation">
      {!isLoading ? (
        <Container>
          {data ? <AmbassadorRenewalConfirmationSuccess /> : <AmbassadorRenewalConfirmationError />}
        </Container>
      ) : (
        <VerifyingSpinner />
      )}
    </div>
  );
}

export function AmbassadorRenewalConfirmationView() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();

  if (featureIsEnabled(COMMUNITY_AMBASSADOR_FEATURE_FLAG, features, searchParams)) {
    return <AmbassadorRenewalConfirmation />;
  }
  return <></>;
}
